import React from 'react';
import * as Lucide from 'lucide-react';
import { CheckCircle2 } from 'lucide-react';
import { MODULES, APPLICATIONS, RUGGED_BADGES, QUALITY_ASSURANCE } from '../mock';

const LightIcon = ({ name, size = 36, iconSize = 18 }) => {
  const Icon = Lucide[name] || Lucide.Circle;
  return (
    <div
      className="inline-flex items-center justify-center rounded-full bg-[#FFF3E4] text-[#F5901F] shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <Icon size={iconSize} strokeWidth={2.2} />
    </div>
  );
};

const ModulesSection = () => {
  return (
    <section id="modules" className="light-section-alt relative py-16 md:py-24">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="reveal-on-scroll">
          <h2 className="font-display font-black text-4xl md:text-6xl leading-tight text-navy mt-2">
            HERTZX&trade; – <span className="orange-accent">MODULAR DEPLOYMENT ARCHITECTURE</span>
          </h2>
          <p className="text-navy-70 mt-3 max-w-3xl">Three intelligent modules. One seamless communication network.</p>
          <div className="mt-4 h-1 w-16 rounded orange-bar" />
        </div>

        {/* Modules */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-10">
          {MODULES.map((m, i) => (
            <div
              key={m.title}
              className="light-card light-card-hover rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 reveal-on-scroll flex flex-col"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Header */}
              <div className="px-6 py-5 flex items-center gap-3 relative">
                <div className="w-11 h-11 rounded-lg bg-[#F5901F] text-black font-black flex items-center justify-center text-xl shrink-0 shadow-sm">
                  {m.letter}
                </div>
                <div className="min-w-0">
                  <div className="font-black text-navy text-xl leading-tight tracking-tight">{m.title}</div>
                  <div className="text-[#F5901F] text-xs font-bold tracking-widest uppercase mt-0.5">{m.sub}</div>
                </div>
              </div>

              {/* Product image */}
              <div className="relative mx-5 rounded-xl overflow-hidden" style={{ background: 'linear-gradient(180deg, #F7F9FC 0%, #EEF2F7 100%)' }}>
                <div className="aspect-[4/3] flex items-center justify-center p-6">
                  <img
                    src={m.img}
                    alt={m.title}
                    loading="lazy"
                    className="max-h-full w-auto object-contain drop-shadow-md transition-transform duration-500 hover:scale-105"
                    style={{ mixBlendMode: 'multiply' }}
                  />
                </div>
              </div>

              {/* Specs list */}
              <div className="px-6 pt-5 pb-6">
                <div className="divide-y divide-[#EEF2F7]">
                  {m.specs.map((s) => (
                    <div key={s.label} className="flex items-center gap-3 py-2.5">
                      <LightIcon name={s.icon} size={32} iconSize={16} />
                      <div className="min-w-0 flex-1 flex items-baseline justify-between gap-3">
                        <span className="text-navy-55 text-[10px] font-bold uppercase tracking-wider shrink-0">{s.label}</span>
                        <span className="text-navy text-sm font-semibold text-right leading-snug">{s.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>


        {/* Rugged + QA */}
    
      </div>
    </section>
  );
};

export default ModulesSection;